import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { StationService } from 'src/app/services/station.service';
import { ReservationService } from 'src/app/services/reservation.service';
import { ArService } from 'src/app/services/ar.service';

@Component({
  selector: 'app-stations',
  templateUrl: './stations.component.html',
  styleUrls: ['./stations.component.scss']
})
export class StationsComponent implements OnInit {

  searchText;
  activePage;
  allStationServices;
  stationsList;

  constructor(private router: Router,
              private spinner: NgxSpinnerService,
              private stationService: StationService,
              private arService: ArService) { 
                this.getData()
              }



  ngOnInit() { 
     this.getData();
  }

  getData() {
    this.searchText = ''
    this.getStationServices();
  }

  addStation() {
    this.router.navigateByUrl("home/add-station");
  }

  outSourced(id){
   // console.log(id)
    if(id == 1){
    return 'Yes'
    } else {
      return 'No'
    }
  }

  editStationService(stationService) {
   // console.log(stationService.id)
    this.router.navigate(["home/edit-station", stationService.id])
  }  
 
  calculateActiveStations(stations) {
    let activeCount = 0
    stations.forEach(station => {
      if (station.OUTSOURCED_STATION) {
        activeCount++
      }
    });
    return activeCount
  }

  calculateInActiveStations(stations) {
    let inactiveCount = 0
    stations.forEach(station => {
      if (!station.OUTSOURCED_STATION) {
        inactiveCount++
      }
    });
    return inactiveCount
  }

  getStationServices() {
    this.spinner.show();
    this.arService.getAllStations().subscribe(res => {
     this.allStationServices = res['result']
    // console.log(this.allStationServices)
     this.spinner.hide();
   });
  }

  getAllStations() {
    this.stationService.getStations().subscribe(stations => {
      this.stationsList = stations['result'];
     // console.log(this.stationsList)
    })
  }

}
